import React, { useRef, useEffect } from "react";
import "./Map.css";
import { defaults as defaultInteractions } from "ol/interaction.js";

import Map from "ol/Map";
import View from "ol/View";

const _Map = ({
  children,
  zoom,
  center,
  disabled,
  projection,
  map,
  setMap = () => {},
}) => {
  const mapRef = useRef();

  //mount
  useEffect(() => {
    try {
      let options = {
        view: new View({
          zoom,
          center,
          projection,
        }),
        layers: [],
        controls: [],
        overlays: [],
      };

      if (disabled) {
        options.interactions = defaultInteractions({
          doubleClickZoom: false,
          dragAndDrop: false,
          dragPan: false,
          keyboardPan: false,
          keyboardZoom: false,
          mouseWheelZoom: false,
          pointer: false,
          select: false,
        });
      }

      let mapObject = new Map(options);
      mapObject.setTarget(mapRef.current);

      setMap(mapObject);

      return () => mapObject.setTarget(undefined);
    } catch (err) {
      console.error(
        new Error(
          "[OLMap/Map] - error when creating map view. Most likely caused by a faulty projection."
        )
      );
    }
  }, [disabled]);

  // zoom
  useEffect(() => {
    if (!map) return;
    map.getView().setZoom(zoom);
  }, [zoom]);

  //center change
  useEffect(() => {
    if (!map) return;
    if (!map.getView().get("center")) {
      map.getView().setCenter(center);
    }
  }, [center]);

  return (
    <div ref={mapRef} className="ol-map">
      {children}
    </div>
  );
};

export default _Map;
